import {
  FETCH_ALL_LICENSE_PERMITS,
} from '../../mutation-types';

export default {
  [FETCH_ALL_LICENSE_PERMITS](state, licensePermits) {
    state.all = licensePermits;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/licensePermitGroup/mutations.js